/* Scroll suave del badge de rating (.rating-badge-link) hacia el widget de
   reseñas de Revie. Lo carga snippets/product-rating.liquid solo cuando recibe
   reviews_anchor (es decir, solo en la página de producto).

   Robusto ante las dos formas en que Revie monta el widget (confirmado por DOM):
   - como sección:  <div id="shopify-section-...">
   - como bloque de app:  <div id="shopify-block-...{hash}__revie_reviews_por_whatsapp_app_block_2_...">
   En ambos casos el contenedor tiene la clase revie_reviews_por_whatsapp_app_block_2
   y, dentro, un id="revieList" (respaldo). El hash del bloque es de runtime, por
   eso NO se puede anclar por id fijo. */
(function () {
  document.addEventListener('click', function (event) {
    var origin = event.target;
    if (!origin || !origin.closest) return;

    var link = origin.closest('.rating-badge-link');
    if (!link) return;

    event.preventDefault();

    var target =
      document.querySelector('[class*="revie_reviews_por_whatsapp_app_block_2"]') ||
      document.getElementById('revieList');

    if (!target) return; // sin destino: no hacemos nada (sin error)

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
